<template>
  <div class="popup">
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div
        v-if="hasMask"
        v-show="isShow"
        class="mask"
        :class="{'absolute':useAbsolutePosition}"
        :style="{bottom: bottomDistance}"
        @touchmove.prevent
        @click="$emit('mask-click')"
      ></div>
    </transition>
    <transition enter-active-class="animated slideIn" leave-active-class="animated slideOut">
      <div
        v-show="isShow"
        class="main-content"
        :class="{'absolute':useAbsolutePosition}"
        :style="{bottom: bottomDistance}"
        @touchmove="handleTouchMove"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class Popup extends Vue {
  @Prop({ type: Boolean, default: false }) isShow!: boolean;
  @Prop({ type: Boolean, default: true }) hasMask!: boolean;
  @Prop({ type: Boolean, default: true }) preventTouchMove!: boolean;
  @Prop({ type: Boolean, default: false }) useAbsolutePosition!: boolean;
  @Prop({ type: String, default: '0px' }) bottomDistance!: string;

  handleTouchMove(e: Event) {
    if (this.preventTouchMove) {
      e.preventDefault();
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  animation-name: fadeIn;
}
.fadeOut {
  animation-name: fadeIn;
  animation-direction: reverse;
}
@keyframes slideIn {
  from {
    transform: translate(0, 100%);
  }
  to {
    transform: translate(0, 0);
  }
}
.animated {
  animation-duration: 0.4s;
}
.popup {
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // z-index: 300;
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 900;
    background-color: rgba($color: #000000, $alpha: 0.7);
  }
  .main-content {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1100;
    // width: 100%;
    // height: 700px;
    background: #fff;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    // transform: translate(0, 100%);
  }
  .absolute {
    position: absolute;
  }
}
.slideIn {
  animation-name: slideIn;
}
.slideOut {
  animation-name: slideIn;
  animation-direction: reverse;
}
</style>
